/**
 * pdf 对外暴露的类型
 */
export var PDFInterface;
(function (PDFInterface) {
    /**
     * 返回状态码
     */
    var EStatusCode;
    (function (EStatusCode) {
        EStatusCode[EStatusCode["SUCCESS"] = 0] = "SUCCESS";
        EStatusCode[EStatusCode["ERROR"] = -1] = "ERROR";
    })(EStatusCode = PDFInterface.EStatusCode || (PDFInterface.EStatusCode = {}));
})(PDFInterface || (PDFInterface = {}));
//# sourceMappingURL=pdf.js.map